<template>
  <div class="itemDetailText">
    <slot name="title"></slot>
    <slot name="text"></slot>
  </div>
</template>

<script>
export default {
  name: 'item-detail-text'
}
</script>

<style lang="scss">
.itemDetailText {
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 1px;

  .title {
    margin-bottom: 8px;
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/ItemDetailText.vue